(function(){
  var trigger = document.querySelector('[data-kby-bac-open]');
  var modal = document.getElementById('kby-bac-modal');
  if(!trigger || !modal) return;

  var mount = modal.querySelector('#kby-bac-mount');
  var closers = modal.querySelectorAll('[data-kby-bac-close]');
  var lastFocus = null;
  var moved = false;

  // The BAC section is added to the page template alongside this launcher —
  // relocate its whole shopify-section wrapper into the modal mount as soon
  // as we can. Doing it on load (not on first open) is what keeps the BAC
  // calculator from briefly rendering inline underneath us before the user
  // clicks the trigger.
  function relocateBac(){
    if(moved) return;
    // The live theme's BAC section roots on .andatech-bac-section; the
    // refactored branch's BAC.liquid was renamed to .atbac. Match either,
    // plus the [data-bac] hook that both variants carry.
    var bacRoot = document.querySelector('.andatech-bac-section, .atbac, [data-bac]');
    if(!bacRoot) return;
    var shopifySection = bacRoot.closest('.shopify-section') || bacRoot;
    var loading = mount.querySelector('.kby-bac-modal__loading');
    if(loading) loading.remove();
    mount.appendChild(shopifySection);
    moved = true;
  }

  // Run once now (in case BAC is already in the DOM) and once on
  // DOMContentLoaded as a safety net for BAC-section scripts that mount
  // later in the parse.
  relocateBac();
  document.addEventListener('DOMContentLoaded', relocateBac);

  function openModal(){
    relocateBac();
    lastFocus = document.activeElement;
    modal.hidden = false;
    document.body.style.overflow = 'hidden';
    var closeBtn = modal.querySelector('.kby-bac-modal__close');
    if(closeBtn) closeBtn.focus();
  }

  function closeModal(){
    modal.hidden = true;
    document.body.style.overflow = '';
    if(lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
  }

  trigger.addEventListener('click', openModal);
  closers.forEach(function(el){ el.addEventListener('click', closeModal); });
  // An in-page link inside the calculator (e.g. its CTA pointing at #shop)
  // should land on that section, not scroll it behind the open modal.
  modal.addEventListener('click', function(e){
    var link = e.target.closest('a[href^="#"]');
    if(link && link.getAttribute('href').length > 1) closeModal();
  });
  document.addEventListener('keydown', function(e){
    if(e.key === 'Escape' && !modal.hidden) closeModal();
  });
})();